import { Controller } from "@hotwired/stimulus"
import $ from "jquery";

export default class extends Controller {
  connect () {
    this.bind_progress();
  }

  initialize() {
  }

  bind_progress() {
    $('.ui.progress').progress();
  }

  disconnect() {
  }
};
